(function () {
  'use strict';
  if (window.drsknnStoreProductControls) return;
  window.drsknnStoreProductControls = true;

  var records = new WeakMap();
  var active = null;
  var popupNames = {
    'size-guide': 'Size guide',
    'delivery-return': 'Delivery & Return',
    'message': 'Product enquiry',
    'pickup-available': 'Store information'
  };
  var dialogSelector = '[data-js-product-gallery-fullscreen], ' + Object.keys(popupNames).map(function (name) {
    return '[data-js-popup-name="' + name + '"]';
  }).join(', ');
  var focusable = 'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function visible(node) {
    if (!node || !node.isConnected || !node.getClientRects().length || node.closest('[inert]')) return false;
    var style = getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.visibility !== 'collapse';
  }

  function release(record) {
    record.background.forEach(function (item) {
      if (!item.wasInert) item.node.removeAttribute('inert');
    });
    record.background = [];
    if (active === record) active = null;
    if (visible(record.opener)) record.opener.focus({ preventScroll: true });
  }

  function prepare(record) {
    if (!record.popupName) return false;
    record.node.setAttribute('role', 'dialog');
    record.node.setAttribute('aria-modal', 'true');
    record.node.setAttribute('aria-label', popupNames[record.popupName]);
    record.node.setAttribute('tabindex', '-1');
    var addedClose = false;
    record.node.querySelectorAll('[data-js-popup-close]').forEach(function (close) {
      if (close.hasAttribute('data-drsknn-product-popup-close')) return;
      close.setAttribute('data-drsknn-product-popup-close', '');
      if (close.tagName !== 'BUTTON') {
        close.setAttribute('role', 'button');
        close.setAttribute('tabindex', '0');
      }
      close.setAttribute('aria-label', 'Close ' + popupNames[record.popupName]);
      addedClose = true;
    });
    return addedClose;
  }

  function focusClose(record) {
    requestAnimationFrame(function () {
      if (active !== record || !record.node.classList.contains('show')) return;
      var close = record.node.querySelector(record.closeSelector);
      (visible(close) ? close : record.node).focus({ preventScroll: true });
    });
  }

  function activate(record) {
    if (active === record) return;
    if (active) release(active);
    record.opener = record.pendingOpener || document.activeElement;
    record.pendingOpener = null;
    record.background = [];
    var branch = record.node;
    while (branch.parentElement) {
      Array.prototype.forEach.call(branch.parentElement.children, function (sibling) {
        if (sibling === branch || /^(SCRIPT|STYLE|LINK)$/.test(sibling.tagName)) return;
        record.background.push({ node: sibling, wasInert: sibling.hasAttribute('inert') });
        sibling.setAttribute('inert', '');
      });
      if (branch.parentElement === document.body) break;
      branch = branch.parentElement;
    }
    active = record;
    focusClose(record);
  }

  function sync(record) {
    var addedClose = prepare(record);
    if (record.node.classList.contains('show')) {
      activate(record);
      if (addedClose && document.activeElement === record.node) focusClose(record);
    }
    else if (active === record) release(record);
  }

  function boot(scope) {
    var nodes = Array.prototype.slice.call(scope.querySelectorAll(dialogSelector));
    if (scope.matches && scope.matches(dialogSelector)) nodes.push(scope);
    nodes.forEach(function (node) {
      if (records.has(node)) return;
      var popupName = node.getAttribute('data-js-popup-name');
      var record = {
        node: node, background: [], opener: null, pendingOpener: null, observer: null,
        popupName: popupName,
        closeSelector: popupName ? '[data-js-popup-close]' : '[data-js-product-gallery-control-fullscreen]'
      };
      records.set(node, record);
      record.observer = new MutationObserver(function () { sync(record); });
      record.observer.observe(node, { attributes: true, attributeFilter: ['class'] });
      sync(record);
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-js-popup-button]');
    if (!trigger || !trigger.closest('.product-page-info__details-buttons, [data-js-pickup-available-container]')) return;
    var name = trigger.getAttribute('data-js-popup-button');
    if (!Object.prototype.hasOwnProperty.call(popupNames, name)) return;
    var node = document.querySelector('[data-js-popup-name="' + name + '"]');
    if (!node) return;
    boot(node);
    var record = records.get(node);
    if (record) record.pendingOpener = trigger;
  }, true);

  document.addEventListener('keydown', function (event) {
    if (!active) return;
    if (!active.node.isConnected) { release(active); return; }
    var targetedClose = event.target.closest && event.target.closest('[data-drsknn-product-popup-close]');
    if (targetedClose && active.node.contains(targetedClose) && targetedClose.tagName !== 'BUTTON' && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault(); event.stopPropagation(); targetedClose.click(); return;
    }
    if (event.key === 'Escape') {
      var close = active.node.querySelector(active.closeSelector);
      if (close) { event.preventDefault(); event.stopPropagation(); close.click(); }
      return;
    }
    if (event.key !== 'Tab') return;
    var controls = Array.prototype.filter.call(active.node.querySelectorAll(focusable), visible);
    var first = controls[0], last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); active.node.focus(); return; }
    if (!active.node.contains(document.activeElement) || document.activeElement === active.node || (event.shiftKey && document.activeElement === first)) {
      event.preventDefault(); (event.shiftKey ? last : first).focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); first.focus();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    if (!active || active.node.contains(event.target)) return;
    var close = active.node.querySelector(active.closeSelector);
    if (visible(close)) close.focus({ preventScroll: true });
  });
  document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var scope = event.target;
    if (active && (scope === active.node || scope.contains(active.node))) release(active);
    var nodes = Array.prototype.slice.call(scope.querySelectorAll(dialogSelector));
    if (scope.matches && scope.matches(dialogSelector)) nodes.push(scope);
    nodes.forEach(function (node) {
      var record = records.get(node);
      if (record) { record.observer.disconnect(); records.delete(node); }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  else boot(document);
})();
